import React from 'react'
import * as css from './css/paySuccess'
import {useHistory} from 'react-router-dom';
import {useEffect} from 'react'

const PaySuccess = () => {
    const history = useHistory();

    const toOrders = () => {
        history.replace('/order');
    }

    return (
        <css.PaySuccess>
            <css.PaySuccessMain>
                <img className='leftTop' src={require('./image/leftTop.png')}/>
                <img className='rightTop' src={require('./image/rightTop.png')}/>
                <css.PaySuccessStatusBlock>
                    <img src={require('./image/success.png')}/>
                    <div className='orderInfo'>
                        <div className='row title'>
                            <span className='orderText'>支付成功！</span>
                            {/*<span>*/}
                            {/*  支付金额： <strong>￥{currentOrder.price}</strong>*/}
                            {/*</span>*/}
                        </div>
                        {/*<div className='row'>*/}
                        {/*  <span className='name'>您的订单编号：</span>*/}
                        {/*  <span className='value'>{currentOrder.id}</span>*/}
                        {/*  <span className='ope'>查看详情</span>*/}
                        {/*</div>*/}
                        {/*<div className='row'>*/}
                        {/*  <span className='name'>下单时间： </span>*/}
                        {/*  <span className='value'>*/}
                        {/*    {currentOrder.time && currentOrder.time.toString()}*/}
                        {/*  </span>*/}
                        {/*</div>*/}
                    </div>
                </css.PaySuccessStatusBlock>
                {/*<css.PaySuccessGoodsInfo>*/}
                {/*  <div className='title'>*/}
                {/*    <img src={require('./image/shop.png')} />*/}
                {/*    <span>{currentOrder.shopName}</span>*/}
                {/*  </div>*/}
                {/*  <div className='body'>*/}
                {/*    <img src={currentOrder.image} />*/}
                {/*    <div className='info'>*/}
                {/*      <p className='name'>{currentOrder.name}</p>*/}
                {/*      <p>{currentOrder.spec}</p>*/}
                {/*      <div className='service'>支持7天无理由退货</div>*/}
                {/*    </div>*/}
                {/*    <div className='price'>*/}
                {/*      ￥{(currentOrder.goodsPrice || 0).toFixed(2)}*/}
                {/*    </div>*/}
                {/*    <div className='num'>x{currentOrder.num || 0}</div>*/}
                {/*  </div>*/}
                {/*</css.PaySuccessGoodsInfo>*/}
                <div className='notification'>
                    安全提醒：为了您的财产安全，不要点击陌生链接、不要向陌生人转账或透漏银行卡和验证码信息，谨防诈骗！
                </div>
            </css.PaySuccessMain>
            <css.Button onClick={toOrders}>查看订单</css.Button>
        </css.PaySuccess>
    )
}

export default PaySuccess
